/*
  GoRoam — live entry math and giveaway schedule (shared by the homepage, entry tags, cart tally).
  Reads Giveaway Gator's storefront config (window.GiveawayGator.config):
    - multiplier: config.entryCalculation.bonusPeriod.multiplier
    - schedule:   bonus-period start/end and the giveaway end, found by key name so a
                  Gator update that renames a field degrades to "not found", never to a wrong date.
  If Gator data is not available, components fall back to the theme-editor settings.

  Entry formula (matches the Official Rules):
    entries = floor(price in USD) * entriesPerDollar * multiplier + bonusEntries
*/
(function () {
  if (window.GoRoamEntries) return;

  var callbacks = [];
  var resolved = false;
  var multiplier = null;

  function cfg() {
    var gg = window.GiveawayGator;
    return (gg && gg.config) || null;
  }

  function readGator() {
    try {
      var c = cfg();
      var m = c && c.entryCalculation && c.entryCalculation.bonusPeriod && c.entryCalculation.bonusPeriod.multiplier;
      m = parseFloat(m);
      return m > 0 ? m : null;
    } catch (e) {
      return null;
    }
  }

  function asDate(v) {
    if (v == null) return null;
    if (typeof v === 'number') { var n = v < 1e12 ? v * 1000 : v; return n > 1e12 ? n : null; }
    if (typeof v === 'string' && /\d{4}-\d{2}-\d{2}/.test(v)) { var t = Date.parse(v); return isNaN(t) ? null : t; }
    if (v && typeof v === 'object' && (v.seconds || v._seconds)) return (v.seconds || v._seconds) * 1000;
    return null;
  }

  // Find the first date-like value under a key matching `re`, searching `obj` up to `depth` levels.
  function findDate(obj, re, depth, skip) {
    if (!obj || typeof obj !== 'object' || depth < 0) return null;
    var keys = Object.keys(obj), i, k, v, d;
    for (i = 0; i < keys.length; i++) {
      k = keys[i]; v = obj[k];
      if (skip && skip.test(k)) continue;
      if (re.test(k)) { d = asDate(v); if (d) return d; }
    }
    for (i = 0; i < keys.length; i++) {
      k = keys[i]; v = obj[k];
      if (skip && skip.test(k)) continue;
      if (v && typeof v === 'object') { d = findDate(v, re, depth - 1, skip); if (d) return d; }
    }
    return null;
  }

  /** { bonusStart, bonusEnd, giveawayEnd } in ms, each null when Gator doesn't publish it. */
  function schedule() {
    var c = cfg(), out = { bonusStart: null, bonusEnd: null, giveawayEnd: null };
    if (!c) return out;
    try {
      var bp = c.entryCalculation && c.entryCalculation.bonusPeriod;
      if (bp) {
        out.bonusStart = findDate(bp, /^(start|starts?At|startDate|start_date|startTime|from|begins?)$/i, 1);
        out.bonusEnd = findDate(bp, /^(end|ends?At|endDate|end_date|endTime|to|until|expires?At|expiry)$/i, 1);
      }
      out.giveawayEnd = findDate(c, /^(end|ends?At|endDate|end_date|endTime|closes?At|closeDate|closingDate|drawDate|drawingDate|entryDeadline|deadline)$/i, 4, /^(bonusPeriod|bonusPeriods|bonus)$/i);
    } catch (e) { /* leave nulls */ }
    return out;
  }

  function finish(value) {
    if (resolved) return;
    resolved = true;
    multiplier = value;
    callbacks.splice(0).forEach(function (cb) { cb(multiplier); });
    document.dispatchEvent(new CustomEvent('goroam:multiplier', { detail: { multiplier: multiplier, schedule: schedule() } }));
  }

  // Poll for up to 6 seconds; Gator's embed loads asynchronously.
  var tries = 0;
  (function poll() {
    var m = readGator();
    if (m) return finish(m);
    if (++tries > 30) return finish(null);
    setTimeout(poll, 200);
  })();

  window.GoRoamEntries = {
    /** cb(multiplier|null) — called once Gator data is known (or timed out). */
    ready: function (cb) {
      if (resolved) cb(multiplier); else callbacks.push(cb);
    },
    schedule: schedule,
    /** { present, active } — present: Gator's config is on the page; active: Gator says a giveaway is live. */
    status: function () { var c = cfg(); return { present: !!c, active: !!(c && c.isActive) }; },
    compute: function (price, mult, bonus, perDollar) {
      var base = Math.floor(price) * (perDollar || 1);
      return { base: base, total: base * (mult || 1) + (bonus || 0) };
    },
    format: function (n) {
      return Math.round(n).toLocaleString('en-US');
    },
    /** For checking in the browser console: GoRoamEntries.debug() */
    debug: function () { return { multiplier: readGator(), schedule: schedule(), config: cfg() }; }
  };
})();
